import { useTranslation } from "react-i18next";
import { useCommonFields } from "./useCommonFields";
import { renderItem } from "../Breaks/renderItem";

const CommonFields = ({ data, type }) => {
    const { t } = useTranslation();

    const result = useCommonFields({ data, type });

    return result?.map(
        (item) =>
            item?.value && (
                <div className="tooltip-content-style">{item?.value && renderItem(item.value, item.label, t)}</div>
            )
    );
};

export default CommonFields;
